<template>
    <b-modal
            id="edit-user-modal"
            :title="title"
            v-model="showModal"
            centered no-close-on-backdrop
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel">

        <b-overlay :show="isLoading" rounded="sm">

            <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

            <form v-if="isLoadingError == false" ref="form" v-on:submit.prevent="noop">
                <b-form-group
                        label="First Name"
                        label-for="firstname-input"
                        invalid-feedback="First Name is required (minimum 3 characters, max 200)"
                        :state="firstNameState">
                    <b-form-input
                            id="firstname-input"
                            placeholder="Enter first name"
                            v-model="firstNameValue"
                            required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                        label="Last Name"
                        label-for="lastname-input"
                        invalid-feedback="Last Name is required (minimum 3 characters, max 200)"
                        :state="lastNameState">
                    <b-form-input
                            id="lastname-input"
                            placeholder="Enter last name"
                            v-model="lastNameValue"
                            required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                    label="Country"
                    label-for="country-input"
                    >
                  <country-select id="country-input"
                                  className="form-control"
                                  v-model="countryValue"
                                  :country="countryValue"
                                  topCountry="US" />
                </b-form-group>
                <b-form-group
                        label="Company Name"
                        label-for="companyname-input"
                        invalid-feedback="(max 200 characters)"
                        :state="companyNameState">
                    <b-form-input
                            id="companyname-input"
                            placeholder=""
                            v-model="companyNameValue"
                            >
                    </b-form-input>
                </b-form-group>
                <b-form-group
                        label="Phone Number"
                        label-for="phonenumber-input"
                        invalid-feedback="(max 20 characters)"
                        :state="phoneNumberState">
                    <b-form-input
                            id="phonenumber-input"
                            placeholder="... ... ...."
                            v-model="phoneNumberValue"
                            >
                    </b-form-input>
                </b-form-group>
            </form>

        </b-overlay>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="primary" @click="ok()">
                Save Changes
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>

        <b-modal id="error-modal" size="sm" title="Action failed" ok-only centered>
            <p class="m-2">There was a problem completing the action, Please try again.</p>
        </b-modal>

    </b-modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ErrorView from '../ErrorView'

    export default {
        name: "UserDetailsModal",
        components: {
            ErrorView
        },
        data() {
            return {
                showModal: false,
                showErrorAlert: true,

                title: "User Details",

                firstNameValue: null,
                lastNameValue: null,

                companyNameValue: null,
                phoneNumberValue: null,

                countryValue: null,

                showValidation: false,
            }
        },
        watch: {
            model(newValue) {
                this.resetModel(newValue);
            },
            showModal(newValue) {
                if(newValue) this.resetModel(this.model);
            }
        },
        computed: {
            ...mapGetters({
                model: 'userAccount/current',
                isModelLoading: 'userAccount/currentLoading',
                isModelLoadingError: 'userAccount/currentLoadingError',
                modelLoadingErrorValue: 'userAccount/currentLoadingErrorValue',
            }),

            isLoading: function() {
                return this.isModelLoading;
            },
            isLoadingError: function() {
                return this.isModelLoadingError;
            },
            loadingErrorValue: function() {
                return this.modelLoadingErrorValue;
            },


            firstNameState: function() {
                if(this.firstNameValue && this.firstNameValue.length > 2 && this.firstNameValue.length < 200) {
                    return true
                }
                return this.showValidation ? false : null
            },
            lastNameState: function() {
                if(this.lastNameValue && this.lastNameValue.length > 2 && this.lastNameValue.length < 200) {
                    return true
                }
                return this.showValidation ? false : null
            },

            companyNameState: function() {
                if(this.companyNameValue) {
                    if(this.companyNameValue.length  < 200)
                        return true;
                    else
                        return this.showValidation ? false : null
                }
                return true
            },
            phoneNumberState: function() {
                if(this.phoneNumberValue) {
                    if(this.phoneNumberValue.length  < 20)
                        return true;
                    else
                        return this.showValidation ? false : null
                }
                return true
            },

            validatedValue: function() {

                if(this.isLoading ||this.isLoadingError) {
                    return null;
                }

                if(this.firstNameState &&
                    this.lastNameState &&
                    this.phoneNumberState &&
                    this.companyNameState) {
                    let value = {
                        userAccountId: this.model ? this.model.userAccountId : undefined,
                        firstName: this.firstNameValue,
                        lastName: this.lastNameValue,
                        companyName: this.companyNameValue,
                        phoneNumber: this.phoneNumberValue,
                        countryCode: this.countryValue,
                    };

                    return value;
                }

                return null;
            },
        },
        methods: {
            ...mapActions({
                save: 'userAccount/save',
            }),
            resetModel(newValue) {
                this.showValidation = false;
                if(newValue) {
                    this.title = "Edit User Details";
                    this.firstNameValue = newValue.firstName;
                    this.lastNameValue = newValue.lastName;
                    this.companyNameValue = newValue.companyName;
                    this.phoneNumberValue = newValue.phoneNumber;
                    this.countryValue = newValue.countryCode;
                }
            },
            handleOk(bvModalEvt) {

                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if(this.isLoading) {
                    return
                }

                if(this.validatedValue != null) {

                    let self = this;
                    this.save(this.validatedValue)
                        .then(function (success) {
                            if(success) {
                                self.resetModel(null);
                                self.closeModal();
                            } else {
                                self.$bvModal.show('error-modal')
                            }
                        })

                } else {
                    this.showValidation = true;
                }
            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if(this.isLoading) {
                    return
                }

                this.closeModal()
            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('edit-user-modal')
                })
            }
        }
    }
</script>

<style scoped>

    div.hide-form-group-label {
        color: white;
    }

</style>